import { i18n } from '@/plugins/i18n'

export const depositStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
}
export const requestStatus = {
    PENDING: 0,
    PAID: 1,
    FAILED: 43,
}
export const depositDestinationBanks ={
    SADERAT: 'saderat',
    SAMAN: 'saman',
}

export const depositStatusStr = {
    ACTIVE: i18n.t('payman_status.active'),
    PENDING: i18n.t('payman_status.pending'),
    REJECTED: i18n.t('payman_status.rejected'),
    BLOCKED: i18n.t('payman_status.blocked'),
    get(status) {
        let status_str = null;
        Object.keys(depositStatus).forEach(function (item) {
            if(depositStatus[item] === status) {
                status_str = depositStatusStr[item]
            }
        })

        return status_str
    }
}
export const requestStatusStr = {
    PENDING: i18n.t('deposit.request_status.pending'),
    PAID: i18n.t('deposit.request_status.paid'),
    FAILED: i18n.t('deposit.request_status.failed'),
    get(status) {
        let status_str = null;
        Object.keys(requestStatus).forEach(function (item) {
            if(requestStatus[item] === status) {
                status_str = requestStatusStr[item]
            }
        })

        return status_str
    }
}
export const depositDestinationBankStr = {
    SAMAN: i18n.t('wallets.bank.saman'),
    SADERAT: i18n.t('wallets.bank.saderat'),
    get(destination_bank) {
        let destination_bank_str = null;
        Object.keys(depositDestinationBanks).forEach(function (item) {
            if(depositDestinationBanks[item] === destination_bank) {
                destination_bank_str = depositDestinationBankStr[item]
            }
        })

        return destination_bank_str
    }
}

export const depositVariant = (status) => {
    if(status === depositStatus.ACTIVE) {
        return 'success'
    }

    if(status === depositStatus.REJECTED || status === depositStatus.BLOCKED) {
        return 'danger'
    }

    if(status === depositStatus.PENDING) {
        return 'warning'
    }

    return 'info'
}
export const requestVariant = (status) => {
    if(status === requestStatus.PAID) {
        return 'success'
    }

    if(status === requestStatus.FAILED) {
        return 'danger'
    }

    if(status === requestStatus.PENDING) {
        return 'warning'
    }

    return 'info'
}